import { render, staticRenderFns } from "./ComponentItems.vue?vue&type=template&id=45be351a&scoped=true"
import script from "./ComponentItems.vue?vue&type=script&lang=js"
export * from "./ComponentItems.vue?vue&type=script&lang=js"
import style0 from "./ComponentItems.vue?vue&type=style&index=0&id=45be351a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45be351a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3338226073/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45be351a')) {
      api.createRecord('45be351a', component.options)
    } else {
      api.reload('45be351a', component.options)
    }
    module.hot.accept("./ComponentItems.vue?vue&type=template&id=45be351a&scoped=true", function () {
      api.rerender('45be351a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ComponentItems.vue"
export default component.exports